import React, { useState, useEffect, useContext } from "react";
import { Grid, Button, TextField } from "@mui/material";
import { observer } from "mobx-react-lite";

import { ErrorMessages } from "../../app/util/messages";
import { validateNumbers } from "../../app/util/util";

const FormDatosEnvio = (props) => {
  const { Entity, IsEdit, OnFinish } = props;

  /* UseStates */
  const [disabled, setDisabled] = useState(true);
  const [model, setModel] = useState(undefined);
  const [errors, setErrors] = useState({
    numeroRemisionFactura: false,
    numeroOrdenCompra: false,
    posicionOrdenCompra: false,
    cantidadBultos: false,
    cantidadMercancia: false,
  });
  const [messages, setMessages] = useState({
    numeroRemisionFactura: undefined,
    numeroOrdenCompra: undefined,
    posicionOrdenCompra: undefined,
    cantidadBultos: undefined,
    cantidadMercancia: undefined,
  });

  /* End UseStates */

  useEffect(() => {
    if (Entity) {
      setModel({ ...Entity });
    }
  }, [Entity]);

  useEffect(() => {
    if (
      !errors.numeroRemisionFactura &&
      !errors.numeroOrdenCompra &&
      !errors.posicionOrdenCompra &&
      !errors.cantidadBultos &&
      !errors.cantidadMercancia
    )
      setDisabled(false);
    else setDisabled(true);
  }, [errors]);

  /* Methods */
  const setValue = (key, value) => {
    setModel({ ...model, ...{ [key]: value } });
  };
  const setError = (key, value) => {
    setErrors({ ...errors, ...{ [key]: value } });
  };
  const setMessage = (key, value) => {
    setMessages({ ...messages, ...{ [key]: value } });
  };
  const validateModel = () => {
    const errors = [],
      objMessages = {};

    if (!model.numeroRemisionFactura) {
      errors.push("numeroRemisionFactura");
      Object.assign(objMessages, {
        numeroRemisionFactura:
          ErrorMessages.envio.details.invoiceShipNumberRequired,
      });
    }
    if (!model.numeroOrdenCompra) {
      errors.push("numeroOrdenCompra");
      Object.assign(objMessages, {
        numeroOrdenCompra:
          ErrorMessages.envio.details.purchaseOrderNumberRequired,
      });
    }
    if (!model.posicionOrdenCompra) {
      errors.push("posicionOrdenCompra");
      Object.assign(objMessages, {
        posicionOrdenCompra:
          ErrorMessages.envio.details.posicionPurchaseOrderRequired,
      });
    }
    if (!model.cantidadBultos) {
      errors.push("cantidadBultos");
      Object.assign(objMessages, {
        cantidadBultos: ErrorMessages.envio.details.quantityBundlesRequired,
      });
    }
    if (!model.cantidadMercancia) {
      errors.push("cantidadMercancia");
      Object.assign(objMessages, {
        cantidadMercancia:
          ErrorMessages.envio.details.quantityMerchandiseRequired,
      });
    }

    if (errors.length > 0) {
      const objErrors = {};
      for (const error of errors) {
        Object.assign(objErrors, { [error]: true });
      }
      setErrors({
        ...errors,
        ...objErrors,
      });
      setMessages({
        ...messages,
        ...objMessages,
      });
    }

    return errors.length <= 0;
  };
  /* End Methods */

  return (
    <>
      <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
        <Grid item sm={6}>
          <TextField
            size="small"
            margin="normal"
            required
            fullWidth
            id="noFactura"
            label="No. de remisión de factura"
            name="noFactura"
            error={errors.numeroRemisionFactura}
            onChange={(e) => {
              setValue("numeroRemisionFactura", e.target.value);
              setError("numeroRemisionFactura", e.target.value.length <= 0);
              setMessage(
                "numeroRemisionFactura",
                e.target.value.length <= 0
                  ? ErrorMessages.envio.details.invoiceShipNumberRequired
                  : ""
              );
            }}
            helperText={messages.numeroRemisionFactura}
            value={model?.numeroRemisionFactura || ""}
          />
        </Grid>
        <Grid item sm={6}>
          <TextField
            size="small"
            margin="normal"
            required
            fullWidth
            id="noOrdenCompra"
            label="No. de orden de compra"
            name="noOrdenCompra"
            inputProps={{ maxLength: 10, minLength: 10 }}
            error={errors.numeroOrdenCompra}
            onChange={(e) => {
              if (e.target.value.length <= 0) {
                setValue("numeroOrdenCompra", e.target.value);
              } else if (
                e.target.value.length <= 10 &&
                validateNumbers(e.target.value)
              ) {
                setValue("numeroOrdenCompra", e.target.value);
              }
              setError(
                "numeroOrdenCompra",
                e.target.value.length <= 0 || e.target.value.length !== 10
              );
              setMessage(
                "numeroOrdenCompra",
                e.target.value.length <= 0
                  ? ErrorMessages.envio.details.purchaseOrderNumberRequired
                  : e.target.value.length !== 10
                  ? ErrorMessages.envio.details
                      .purchaseOrderNumberLengthIncorrect
                  : ""
              );
            }}
            helperText={messages.numeroOrdenCompra}
            value={model?.numeroOrdenCompra || ""}
          />
        </Grid>
        <Grid item sm={6}>
          <TextField
            size="small"
            margin="normal"
            required
            fullWidth
            id="posicionOrden"
            label="Posición de orden de compra"
            name="posicionOrden"
            error={errors.posicionOrdenCompra}
            onChange={(e) => {
              if (e.target.value.length <= 0) {
                setValue("posicionOrdenCompra", e.target.value);
              } else if (
                e.target.value.length > 0 &&
                validateNumbers(e.target.value)
              ) {
                setValue("posicionOrdenCompra", e.target.value);
              }
              setError("posicionOrdenCompra", e.target.value.length <= 0);
              setMessage(
                "posicionOrdenCompra",
                e.target.value.length <= 0
                  ? ErrorMessages.envio.details.posicionPurchaseOrderRequired
                  : ""
              );
            }}
            helperText={messages.posicionOrdenCompra}
            value={model?.posicionOrdenCompra || ""}
          />
        </Grid>
        <Grid item sm={3}>
          <TextField
            size="small"
            margin="normal"
            required
            fullWidth
            id="bultos"
            label="Cantidad de bultos"
            name="bultos"
            error={errors.cantidadBultos}
            onChange={(e) => {
              if (e.target.value.length <= 0) {
                setValue("cantidadBultos", e.target.value);
              } else if (
                e.target.value.length > 0 &&
                validateNumbers(e.target.value)
              ) {
                setValue("cantidadBultos", e.target.value);
              }
              setError(
                "cantidadBultos",
                e.target.value.length <= 0 || parseInt(e.target.value) < 1
              );
              setMessage(
                "cantidadBultos",
                e.target.value.length <= 0
                  ? ErrorMessages.envio.details.quantityBundlesRequired
                  : parseInt(e.target.value) < 1
                  ? ErrorMessages.envio.details.quantityBundlesMinPermitted
                  : ""
              );
            }}
            helperText={messages.cantidadBultos}
            value={model?.cantidadBultos || ""}
          />
        </Grid>
        <Grid item sm={3}>
          <TextField
            size="small"
            margin="normal"
            required
            fullWidth
            id="mercancia"
            label="Cantidad de mercancía"
            name="mercancia"
            error={errors.cantidadMercancia}
            onChange={(e) => {
              if (e.target.value.length <= 0) {
                setValue("cantidadMercancia", e.target.value);
              } else if (
                e.target.value.length > 0 &&
                validateNumbers(e.target.value)
              ) {
                setValue("cantidadMercancia", e.target.value);
              }
              setError(
                "cantidadMercancia",
                e.target.value.length <= 0 || parseInt(e.target.value) < 1
              );
              setMessage(
                "cantidadMercancia",
                e.target.value.length <= 0
                  ? ErrorMessages.envio.details.quantityMerchandiseRequired
                  : parseInt(e.target.value) < 1
                  ? ErrorMessages.envio.details.quantityMerchandiseMinPermitted
                  : ""
              );
            }}
            helperText={messages.cantidadMercancia}
            value={model?.cantidadMercancia || ""}
          />
        </Grid>
      </Grid>
      <Grid
        container
        direction={"row"}
        justifyContent="end"
        alignItems={"center"}
        mb={2}
      >
        <Grid item>
          <Button
            disabled={disabled}
            variant="contained"
            onClick={() => {
              if (validateModel()) OnFinish(model);
            }}
          >
            {IsEdit ? "Actualizar" : "Agregar"}
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default observer(FormDatosEnvio);
